<template lang="html">
  <div class="accordion">
    <div @click.prevent="toggle">
      <slot name="header" ></slot>
    </div>
    <transition name="slide-down"
    v-on:before-enter="beforeEnter" v-on:enter="enter"
          v-on:before-leave="beforeLeave" v-on:leave="leave">
      <div class="accordion-content" v-show="open">
        <slot></slot>
      </div>
    </transition>

    <div class="accordion-btn">
      <a href="#" @click.prevent="toggle">
      <span class="fa fa-angle-down"></span></a>
    </div>
  </div>
</template>

<script>
export default {
  name: "accordion",

  props: {
    "is-open": {
      type: Boolean,
      default: false
    }
  },

  data: function() {
    return {
      open: this.isOpen,
      height: this.initialHeight
    };
  },

  mounted: function() {
    if (this.isOpen) {
      this.$el.style.height = this.$el.scrollHeight + "px";
    }

    this.$nextTick(function() {
      window.addEventListener("resize", this.handleResize);
    });
  },

  methods: {
    toggle: function() {
      this.open = !this.open;
    },
    beforeEnter: function(el) {
      this.$el.style.height = 0;
    },
    enter: function(el) {
      this.$el.style.height = this.$el.scrollHeight + "px";
    },
    beforeLeave: function(el) {
      this.$el.style.height = this.$el.scrollHeight + "px";
    },
    leave: function(el) {
      this.$el.style.height = 0;
    },
    handleResize: function() {
      if (this.open) {
        this.$el.style.height = "auto";
      }
    }
  }
};
</script>

<style lang="css">
</style>
